import InstanceApi from "@/services/apiClient.js";
import Vue from 'vue'

import {
  formatSaveOrderRequest
} from "@/helpers/checkout";

const SAVE_ORDER_URL = "mcp/checkout/saveOrder";
const PAYMENT_TOKEN_ERROR_MESSAGE =
  "Une erreur s'est produite lors de la vérification de vos coordonnées bancaires";

const setCheckoutInfoDataRequired = (state, payload) => {
  state.commit("SET_CHECKOUT_INFO_DATA_REQUIRED", payload);
};

const setCheckoutInfoOptional = (state, payload) => {
  state.commit("SET_CHECKOUT_INFO_OPTIONAL", payload);
};

const setCheckoutFillPercent = (state, percent) => {
  state.commit("SET_CHECKOUT_FILL_PERCENT", percent);
};

const addRequiredCompanyToStore = state => {
  state.rootState.Checkout.checkout.required.infos["company"] = "";
};

const setCheckoutRentingInfoDataRequired = (state, payload) => {
    state.commit("SET_CHECKOUT_RENTING_INFO_DATA_REQUIRED", payload);
};

const toogleInfoDataRequired = (state, payload) => {
  let arrayToConvert = state.rootState.Checkout.checkout.billingInfo;
  let arrayWithData = state.rootState.Checkout.checkout.required.infos;
  if (payload) {
    Object.entries(arrayWithData).forEach(element => {
      if(arrayToConvert.hasOwnProperty(element[0])) {
      arrayToConvert[element[0]] = element[1];
      }
    });
    Object.entries(arrayToConvert).forEach(element => {
      delete arrayWithData[element[0]];
    });
  } else {
    Object.entries(arrayToConvert).forEach(element => {
      arrayWithData[element[0]] = element[1];
    });
  }
};

const removeRequiredCompanyToStore = state => {
  delete state.rootState.Checkout.checkout.required.infos.company;
};

const doCheckoutRenting = async ({ getters, rootGetters }) => {
    try {
        const requiredInfo            = getters.getCheckoutInfoRequired;
        const additionalInfo          = getters.getCheckoutInfoOptional;
        const currentUserShippingInfo = rootGetters.getCurrentUserShippingInfo;
        const storeUrlPrefix          = rootGetters.getStoreUrlPrefix;

        /* format saveOrder data */
        let bodyFormData = formatSaveOrderRequest(
            requiredInfo,
            additionalInfo,
            null,
            null,
            currentUserShippingInfo,
            "free",
            storeUrlPrefix == "/be" ? "BE": "FR",
            );

        /* call save order data */
        const saveOrderResponse = await InstanceApi.post(SAVE_ORDER_URL, bodyFormData);

        /* in case saveOrder failed, we exit the checkout process */
        if (saveOrderResponse.data.messages && saveOrderResponse.data.messages.error)
            throw saveOrderResponse.data.messages.error || "failure";

        /* in case of success, we redirect the user to the success page */
        location.replace(saveOrderResponse.data.redirect);

    } catch (err) {
        console.log("saveOrder failure", err);
        return { error: err };
    }
    return { success: "" };
};

const saveCustomerData = async ({ getters, rootGetters }) => {
  try {
    const requiredInfo = getters.getCheckoutInfoRequired;
    const additionalInfo = getters.getCheckoutInfoOptional;
    const currentUserShippingInfo = rootGetters.getCurrentUserShippingInfo;
    const storeUrlPrefix = rootGetters.getStoreUrlPrefix;

    let bodyFormData = formatSaveOrderRequest(
      requiredInfo,
      additionalInfo,
      null,
      null,
      currentUserShippingInfo,
      "free",
      storeUrlPrefix == "/be" ? "BE": "FR",
    );

    const saveCustomerData = await InstanceApi.post("/mcp/checkout/saveCustomerData", bodyFormData);

    if(!saveCustomerData.data.success){
      throw saveCustomerData.data.message;
    }

  } catch (err) {
    return { error: err };
  }
  return { success: "" };
};

const doCheckout = async ({ getters, rootGetters }) => {
  try {
    const paymentToken = rootGetters.getDalenysToken;
    const paypalMethodName = rootGetters.getPaypalMethodName;
    const requiredInfo = getters.getCheckoutInfoRequired;
    const additionalInfo = getters.getCheckoutInfoOptional;
    const choosenPaymentMethod = rootGetters.getChoosenPaymentMethod;
    const currentUserShippingInfo = rootGetters.getCurrentUserShippingInfo;
    const storeUrlPrefix = rootGetters.getStoreUrlPrefix;

    /* throw an error in case there is no payment token (for cb/amex) */
    if ( process.env.NODE_ENV !== 'development' &&
      choosenPaymentMethod.code !== paypalMethodName &&
      (!paymentToken || !paymentToken.length)
    )
      throw PAYMENT_TOKEN_ERROR_MESSAGE;

    let bodyFormData = formatSaveOrderRequest(
      requiredInfo,
      additionalInfo,
      choosenPaymentMethod,
      paymentToken,
      currentUserShippingInfo,
      process.env.NODE_ENV === 'development' ? "cashondelivery" : "be2bill",
      storeUrlPrefix == "/be" ? "BE": "FR",
    );

    /* call save order data */
    const saveOrderResponse = await InstanceApi.post(SAVE_ORDER_URL, bodyFormData);

    if (saveOrderResponse.data.messages && saveOrderResponse.data.messages.error)
      throw saveOrderResponse.data.messages.error || "failure";

    // in dev mode, we don't redirect to payment page but directly to success page
    if(process.env.NODE_ENV === 'development'){
      //location.replace(saveOrderResponse.data.redirect);
    }else{
      const paymentRedirectLink = saveOrderResponse.data.redirect;
      const paymentResponse = await InstanceApi.post(paymentRedirectLink);

      if (paymentResponse.data.messages && paymentResponse.data.messages.error)
        throw paymentResponse.data.messages.error || "failure";

      location.replace(paymentResponse.data.redirect);
    }

  } catch (err) {
    console.log("saveOrder failure", err);
    return { error: err };
  }
  return { success: "" };
};

const setOptinData = (state, payload) => {
  state.commit("SET_OPTIN_DATA", payload);
};

export default {
  setCheckoutInfoDataRequired,
  setCheckoutInfoOptional,
  setCheckoutFillPercent,
  addRequiredCompanyToStore,
  removeRequiredCompanyToStore,
  toogleInfoDataRequired,
  doCheckout,
  doCheckoutRenting,
  saveCustomerData,
  setCheckoutRentingInfoDataRequired,
  setOptinData
};
